export const GET_MEMO_COUNT = "GET_MEMO_COUNT"
export const GET_MEMO_COUNT_SUCCESS = "GET_MEMO_COUNT_SUCCESS"

